import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { t } from "@/i18n";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const PendingDialog = ({ open, onOpenChange, phase = 3, registered = false, extra }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="pending-dialog" className="border-[#303030] bg-[#1b1b1b] text-[#f4f1ec]">
      <DialogHeader>
        <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-lg border border-[#4d3a14] bg-[#1e1808] text-[#f5b544]"><Lock size={18} /></div>
        <DialogTitle className="font-display">{t.pendingDialog.title}</DialogTitle>
        <DialogDescription className="text-[#a3a3a3]">{t.pendingDialog.body(phase)}</DialogDescription>
      </DialogHeader>
      {extra && <p className="text-sm text-[#d8d4cd]">{extra}</p>}
      <p className="text-sm text-[#a3a3a3]">{registered ? t.pendingDialog.registered : t.pendingDialog.notRegistered}</p>
      <div className="mt-2 flex justify-end gap-2">
        {registered && (
          <Link to="/tasks" className="v-btn-ghost v-btn-sm" data-testid="pending-dialog-view-tasks" onClick={() => onOpenChange(false)}>{t.pendingDialog.viewTasks}</Link>
        )}
        <button className="v-btn-primary v-btn-sm" data-testid="pending-dialog-close" onClick={() => onOpenChange(false)}>{t.common.understood}</button>
      </div>
    </DialogContent>
  </Dialog>
);

export default PendingDialog;
